import UserChallengeImage from './UserChallengeImage';

export default UserChallengeImage;
